import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useLang } from "../../../../../../language";
import { InputRadios } from "../../../../../../components/Inputs/InputRadios";
import { InputText } from "../../../../../../components/Inputs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { ButtonSpinner } from "../../../../../../components/ButtonSpinner/ButtonSpinner";
import { AlquilerServices } from "../services/alquileres.service";
import { isStatusSucess } from "../../../../../../helpers/helpers";
import { useValidator } from "../../../../../../hooks/useValidator";
import { InputChecks } from "../../../../../../components/Inputs/InputChecks";
import { cloneDeep } from "lodash";

export const ModalGenerarFactura = ({ data, handleClose, handleSubmitPedidoGenerar, fetchPedidoGenerarPOSTData,
    formInscripcion, currentTarifa, idpedido, fetchCondicionPagosGETData, formCobro, handleInputChangeCobro,
    handleFormInscripcion, resetformCobro
}: any) => {

    const Lang = useLang()

    const [valuesValidationCobro, handleValidationCobro, handleResetValidationCobro] = useValidator({
        fechacobro: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })


    const [fetchPedidoPATCH, fetchPedidoPATCHData, resetfetchPedidoPATCH] = AlquilerServices.PATCH(idpedido)

    const handleSubmitEditarInscripcion = () => {

        fetchPedidoPATCH({
            body: {
                ...formInscripcion,
                inputtotalimportebase: currentTarifa.totalimportebase,
                inputtotalimporteiva: (currentTarifa.importeiva / 100 * Number(currentTarifa.totalimportebase)).toFixed(2),
                idiva: currentTarifa.idiva,
            }
        })
    }

    const handleSubmitAll = () => {

        if (formCobro.estado !== 'C' || handleValidationCobro(formCobro)) {

            handleSubmitEditarInscripcion()
        }
    }

    useEffect(() => {

        if (isStatusSucess(fetchPedidoPATCHData.status)) {

            handleSubmitPedidoGenerar()
        }

    }, [fetchPedidoPATCHData]);

    const [condPago, setcondPago] = useState('');

    useEffect(() => {

        if (data.value && fetchCondicionPagosGETData) {

            const condPago = fetchCondicionPagosGETData?.data?.items?.find((item: any) => item.id === formInscripcion.idcondicionpago)?.tipocondicionpago

            setcondPago(condPago)

        } else {

            setcondPago('')
            resetformCobro()
        }

    }, [data.value, fetchCondicionPagosGETData]);

    // useEffect(() => {

    //     if (condPago === 'remesa') {

    //         handleSubmitAll()
    //     }

    // }, [condPago]);



    // Funciones helpers

    const handleChangeCheck = (e: any, name: string) => {

        let listaModulosTemp = cloneDeep(formInscripcion[name])

        if (e.target.checked) {

            listaModulosTemp.push(e.target.name)

        } else {

            listaModulosTemp = listaModulosTemp.filter((item: any) => item !== e.target.name)
        }

        handleFormInscripcion({
            ...formInscripcion,
            [name]: listaModulosTemp
        })
    }

    return (
        <>
            <Modal show={data.value} onHide={handleClose} id='ModalRegistro'>
                <Modal.Header closeButton className='border-bottom-0 py-4'>
                    <Modal.Title className='h5'>{Lang('GENERAR_FACTURA')}</Modal.Title>

                </Modal.Header>
                <Modal.Body className='px-4 py-0'>

                    <section className="row justify-content-center">

                        {
                            condPago === 'remesa' ?
                                <>
                                    {/* <p className="text-center my-4">
                                        {Lang('GENERANDO_FACTURA')}
                                    </p> */}
                                </>
                                :
                                <>
                                    <Form.Group className="mb-3 col-12 text-center">
                                        <Form.Label className='fw-500 d-block'>{Lang('PARRAFO_FACTURA_HA_SIDO_PAGADA')}</Form.Label>
                                        <InputRadios
                                            className=''
                                            name='estado'
                                            value={formCobro.estado}
                                            values={[
                                                { id: 'P', nombre: 'No' },
                                                { id: 'C', nombre: 'Si' },
                                            ]}
                                            onChange={handleInputChangeCobro}

                                        />
                                    </Form.Group>

                                    {
                                        formCobro.estado === 'C' ? <Form.Group className="mb-3 col-12 col-md-7 col-lg-6 col-xl-7">
                                            <InputText
                                                label={`${Lang('FECHA_COBRO')}:`}
                                                type='date'
                                                name='fechacobro'
                                                value={formCobro.fechacobro}
                                                onChange={handleInputChangeCobro}
                                                validation={valuesValidationCobro}

                                            />
                                        </Form.Group>
                                            :
                                            <>
                                                {
                                                    condPago === 'transferencia' &&
                                                    <Form.Group className="mb-3 col-12 col-md-7 col-lg-6 col-xl-7">
                                                        <InputText

                                                            label={Lang('FECHA_VENCIMIENTO') + ':'}
                                                            type='date'
                                                            name='fechavencimiento'
                                                            value={formCobro.fechavencimiento}
                                                            onChange={handleInputChangeCobro}
                                                        />
                                                    </Form.Group>

                                                }
                                            </>

                                    }
                                </>
                        }

                        <Form.Group className="mb-3 col-12">
                            <div className="row justify-content-center">
                                <InputChecks
                                    classNameContainer='d-inline-block me-4 col flex-grow-0 text-nowrap mt-2'
                                    name='comunicar'
                                    value={formInscripcion.comunicar}
                                    values={[{ id: 'comunicar', nombre: Lang('NOTIFICAR_POR_EMAIL') }]}
                                    // classNameContainer='col-12 col-lg-6 col-xl-4 mb-3'
                                    onChange={(e: any) => handleChangeCheck(e, 'comunicar')}
                                // fetchData={nuevo ? fetchPersonaPOSTData : fetchPerfilesPATCHData}
                                />

                            </div>
                        </Form.Group>

                    </section>

                </Modal.Body>
                <Modal.Footer className='border-0 d-flex justify-content-between'>
                    <Button variant="outline-primary" onClick={handleClose}>
                        {Lang('SALIR')}
                    </Button>
                    <ButtonSpinner
                        variant="secondary" type="button" className="ms-auto"
                        handleSubmit={handleSubmitAll}
                        fetchDataLoading={[fetchPedidoGenerarPOSTData.loading, fetchPedidoPATCHData.loading]}
                        value={Lang('GENERAR_FACTURA')} icon={<FontAwesomeIcon icon={faSave} className='me-1' />}
                    />
                </Modal.Footer>
            </Modal>
        </>
    )
};
